export const contentTableConfig = {
  title: '客户删除列表',
  propList: [
    {prop: 'uname', label: '客户昵称', minWidth: '80'},
    {prop: 'remark', label: '备注', minWidth: '80'},
    {prop: 'unionId', label: 'UnionID', minWidth: '80'},
    {prop: 'corpName', label: '主体名称', minWidth: '80'},
    {prop: 'sid', label: '账号ID', minWidth: '80'},
    {prop: 'usedBy', label: '使用人', minWidth: '80'},
    {prop: 'deptName', label: '所属岗位', minWidth: '80'},
    {prop: 'groupName', label: '所属组', minWidth: '80'},
    {prop: 'createdAt', label: '添加时间', minWidth: '80'},
    {prop: 'deletedAt', label: '删除时间', minWidth: '80'},
    {prop: 'isDayDeleted', label: '是否指定天数内删除', minWidth: '100'}
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
